import { panelType } from '@bimser/common';
import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';

export interface IBaseSetPanelAction<T = any> {
	panelId?: string;
	panelType?: panelType;
	data?: T;
}

export interface ISetPanelAction<T = any> extends IBaseSetPanelAction<T> {}

export interface IReadonlySetPanelAction<T = any> extends IBaseSetPanelAction<T> {}

export type SetPanelAction<T = any> = ReadonlyRecord<IReadonlySetPanelAction<T>>;

export const SetPanelFactory = Record<IReadonlySetPanelAction>({
	panelId: '',
	panelType: null,
	data: null
});

export const SetPanelActionFactoryFromJS = function <T = any>(data: ISetPanelAction<T>) {
	return SetPanelFactory(data) as Record<IReadonlySetPanelAction<T>> &
		Readonly<IReadonlySetPanelAction<T>>;
};
